import { connect } from 'react-redux'
import { loadJobsForDevice } from '../../../store/jobs'
import StatsView from '../components/StatsView'
import _ from 'lodash'

const mapDispatchToProps = {
  loadJobsForDevice,
}

const mapStateToProps = (state, ownProps) => ({
  jobs: _.filter(state.jobs, (job) => job.device_string === ownProps.params.device_string)
})

export default connect(mapStateToProps, mapDispatchToProps)(StatsView)



// WEBPACK FOOTER //
// ./src/routes/Stats/containers/StatsContainer.js